import charMap from './reference/character-map';

export var FULL_CHALLENGING_CHARACTERS = 'Пβシ耐克บั้ รื่بُو';
export var PARTIAL_CHALLENGING_CHARACTERS = '耐克รื่بُو';
export var EXPANDING_CHAR_STRING = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

/**
 * Performs the expansion of a given string, before pseudo is applied.
 *
 * @param {string} str - The original string to expand
 * @param {number} expansionPercent - The percent to increase the text by
 * @param {string} challengeChars - The characters to append
 * @return {string} Return
 */
export function expandString(str, expansionPercent) {
  var challengeChars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FULL_CHALLENGING_CHARACTERS;

  var finalStr = str + ' ';

  // How many extra characters need to be added
  // to the original string on top of the challenge chars?
  var addLength = Math.round(str.length * (expansionPercent / 100)) - challengeChars.length;

  // Add expansion chars if necessary
  if (addLength > 0) {
    finalStr += '' + EXPANDING_CHAR_STRING.substr(0, addLength);
  }

  // Always append the challenge chars
  finalStr += challengeChars;

  return finalStr;
}

/**
 * Transforms a normal string to a pseudo string.
 *
 * @param {string} str - The string to pseudolocalize
 * @return {string}
 */
export default function generatePseudo() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var finalStr = str;

  // Return if there's no string or it's empty
  if (!finalStr || finalStr.length === 0) {
    return '';
  }

  // Expansion percent agreements: https://jira.nike.com/browse/LT-219

  // XXS -> at most 3 characters, 150% expansion, partial challenging characters
  if (str.length <= 3) {
    finalStr = expandString(str, 150, PARTIAL_CHALLENGING_CHARACTERS);
  }

  // XS -> 3 < x <= 10 characters, 100% expansion, partial challenging characters
  else if (str.length <= 10) {
      finalStr = expandString(str, 100, PARTIAL_CHALLENGING_CHARACTERS);
    }

    // S -> 10 < x <= 20 characters, 80% expansion, full challenging characters
    else if (str.length <= 20) {
        finalStr = expandString(str, 80);
      }

      // M -> 20 < x <= 30 characters, 70% expansion, full challenging characters
      else if (str.length <= 30) {
          finalStr = expandString(str, 70);
        }

        // L -> 30 < x <= 70 characters, 40% expansion, full challenging characters
        else if (str.length <= 70) {
            finalStr = expandString(str, 40);
          }

          // XL -> more than 70 characters, 30% expansion, full challenging characters
          else {
              finalStr = expandString(str, 30);
            }

  var prepend = '[';
  var append = ']';

  // The characters we should ignore or leave alone
  var ignoreMap = {
    '{': function _(char) {
      return char === '}';
    },
    '<': function _(char) {
      return char === '>';
    }
  };

  // Starting out with our prepend
  var output = prepend;

  var char = void 0;
  var ignoreFn = void 0;

  for (var i = 0, c = finalStr.length; i < c; i += 1) {
    char = finalStr[i];

    // if we can stop ignoring
    if (ignoreFn && ignoreFn(char, i)) {
      ignoreFn = null;
    }

    if (!ignoreFn) {
      ignoreFn = ignoreMap[char];
      if (!ignoreFn && charMap[char]) {
        char = charMap[char];
      }
    }

    output += char;
  }

  // End with our append
  return output + append;
}